export default class RTEContent {
	constructor(config) {
		this.el = config.el;

		this.init();
	}
	init() {
		this.addAriaHiddenToImages();
		this.addAriaHiddenToCaption();
	}
	addAriaHiddenToImages() {
		if (!this.el) return;

		const images = this.el.querySelectorAll('img');
		images.forEach((img) => {
			const imgAlt = img.getAttribute('alt');
			const imgTitle = img.getAttribute('title');

			if (!imgAlt && imgTitle != null) {
				img.setAttribute('aria-hidden', 'true');
			}
		});
	}

	addAriaHiddenToCaption() {
		if (!this.el) return;

		const imgCaptions = this.el.querySelectorAll('.imagecaption');
		imgCaptions.forEach((caption) => {
			caption.setAttribute('aria-hidden', 'true');
		});
	}
}
